/**
 * Cookie name for storing attribution data (UTM parameters and paid IDs)
 */
export const ATTRIBUTION_COOKIE_NAME = 'trscnd_attr';

/**
 * Number of days the attribution cookie should persist
 */
export const ATTRIBUTION_COOKIE_EXPIRATION_DAYS = 7;
